import { render, staticRenderFns } from "./HomeLight.vue?vue&type=template&id=5677b818&scoped=true&"
import script from "./HomeLight.vue?vue&type=script&lang=js&"
export * from "./HomeLight.vue?vue&type=script&lang=js&"
import style0 from "./HomeLight.vue?vue&type=style&index=0&id=5677b818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677b818",
  null
  
)

export default component.exports